import { useEffect, useState } from 'react';

export interface Countdown {
  passed: boolean;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalMs: number;
}

function compute(deadline: string | null | undefined): Countdown {
  if (!deadline) {
    return { passed: false, days: 0, hours: 0, minutes: 0, seconds: 0, totalMs: 0 };
  }
  const diff = new Date(deadline).getTime() - Date.now();
  if (isNaN(diff) || diff <= 0) {
    return { passed: true, days: 0, hours: 0, minutes: 0, seconds: 0, totalMs: 0 };
  }
  const totalSec = Math.floor(diff / 1000);
  return {
    passed: false,
    days: Math.floor(totalSec / 86400),
    hours: Math.floor((totalSec % 86400) / 3600),
    minutes: Math.floor((totalSec % 3600) / 60),
    seconds: totalSec % 60,
    totalMs: diff,
  };
}

/** Live countdown to an ISO deadline; ticks every second. */
export function useCountdown(deadline: string | null | undefined): Countdown {
  const [now, setNow] = useState(() => compute(deadline));
  useEffect(() => {
    setNow(compute(deadline));
    if (!deadline) return;
    const id = setInterval(() => setNow(compute(deadline)), 1000);
    return () => clearInterval(id);
  }, [deadline]);
  return now;
}
